import React, { useEffect, useState } from "react";

function Circle({ color }) {
  const [animateToY, setAnimateToY] = useState(0);
  const [animateToX, setAnimateToX] = useState(0);
  const [rotation, setRotation] = useState(0);
  useEffect(() => {
    const randomY = 50+Math.round(Math.floor(Math.random() * 10) - 5);
    const randomX = 50+Math.round(Math.floor(Math.random() * 10) - 5);
    setAnimateToY(randomY);
    setAnimateToX(randomX);
    const randomRotation = Math.round(Math.random());
    setRotation(randomRotation);
  }, []);

  return (
    <div
      className={`circle ${color} ${rotation === 1 ? "rotate" : ""}`}
      style={{ transformOrigin: `${animateToX}% ${animateToY}%` }}
    ></div>
  );
}

function Circles({ color }) {
  return (
    <div className="circles">
      <Circle color={color} />
      <Circle color={color} />
      <Circle color={color} />
      <Circle color={color} />
      <Circle color={color} />
      <Circle color={color} />

    </div>
  );
}

export default Circles;
